import Admin from '@views/mainlayout'

// const RouteView = {
//     name: 'RouteView',
//     render: (h) => h('keep-alive', [h('router-view')])
// }
const RouteView = {
    name: 'RouteView',
    render: (h) => h('router-view')
}
const route1 = [
    {
        path: '/',
        redirect: '/train/trainManage/task-list'
    },
    {
        path: '/train',
        name: 'admin',
        component: Admin,
        children: [
            {
                path: '/train/project-list',
                name: '项目管理',
                meta: {
                    needlogin: true,
                    role: [1, 2]
                },
                component: () => import('@views/ProjectManage'),
            },
            {
                path: '/train/trainManage',
                name: '训练管理',
                icon: 'radar-chart',
                meta: {
                    needlogin: true,
                },
                component: RouteView,
                children: [
                    {
                        path: '/train/trainManage/project-resources',
                        name: '资源管理(训练)',
                        meta: {
                            needlogin: true,
                            role: [1, 2]
                        },
                        component: () => import('@views/ResourceManage'),
                    },
                    {
                        path: '/train/trainManage/task-list',
                        name: '任务管理(训练)',
                        meta: {
                            needlogin: true,
                            role: [1, 2]
                        },
                        component: () => import('@views/MissionManage')
                    },
                ]
            },
            {
                path: '/train/test',
                name: '测试管理',
                meta: {
                    needlogin: true,
                    role: [1]
                },
                component: RouteView,
                children: [
                    {
                        path: '/train/test/TestResourceManage',
                        name: '资源管理(测试)',
                        meta: {
                            needlogin: true,
                            role: [1]
                        },
                        component: () => import('@views/TestResoureManage')
                    },
                    {
                        path: '/train/test/TestMissionManage',
                        name: '任务管理(测试)',
                        meta: {
                            needlogin: true,
                            role: [1]
                        },
                        component: () => import('@views/TestMissionManage')
                    },

                ]
            },
            {
                path: '/train/transform',
                name: '模型转换',
                meta: {
                    needlogin: true,
                    role: [1, 2]
                },
                component: () => import('@views/Transform'),
            },
            {
                path: '/train/semiLearn',
                name: '半监督学习',
                meta: {
                    needlogin: true,
                    role: [1, 2]
                },
                component: RouteView,
                children: [
                    {
                        path: '/train/semiLearn/SemiResourceManage',
                        name: '资源管理(半监督)',
                        meta: {
                            needlogin: true,
                            role: [1, 2]
                        },
                        component: () => import('@views/SemiLearn/SemiResourceManage')
                    },
                    {
                        path: '/train/semiLearn/SemiMissionManage',
                        name: '任务管理(半监督)',
                        meta: {
                            needlogin: true,
                            role: [1, 2]
                        },
                        component: () => import('@views/SemiLearn/SemiMissionManage')
                    },

                ]
            },
            {
                path: '/train/system',
                name: '系统管理',
                icon: 'setting',
                meta: {
                    needlogin: true,
                    role: [1]
                },
                component: RouteView,
                children: [
                    {
                        path: '/train/system/user-list',
                        name: '用户管理',
                        meta: {
                            needlogin: true,
                            role: [1]
                        },
                        component: () => import('@views/UserManage'),
                    },
                    {
                        path: '/train/system/enterprise-list',
                        name: '企业管理',
                        meta: {
                            needlogin: true,
                            role: [1]
                        },
                        component: () => import('@views/BusinessManage')
                    },
                ]
            },
            {
                path: '/train/ErrorLog',
                name: '错误日志',
                meta: {
                    needlogin: true,
                    role: [1, 2]
                },
                component: () => import('@views/ErrorLog')
            }
        ]
    },
    {
        path: '/login',
        name: '登录',
        meta: {
            needlogin: false
        },
        component: () => import('@views/Login')
    },
    // {
    //     path: '/login',
    //     name: '登录',
    //     meta: {
    //         needlogin: false
    //     },
    //     component: () => import('@views/Login2')
    // },
    {
        path: '*',
        name: '404',
        component: () => import('@views/NoFind')
    },
    {
        path: '/NoNet',
        name: '无网',
        component: () => import('@views/NoNet')
    },
]


// const usertype = JSON.parse(localStorage.getItem('user_type'))
// let routes = []
// if(usertype == 2){
//   route1[1].children.pop()
//   route1[1].children[0].children.shift()
//   console.log(111);
// }
// console.log(route1);
export default route1